import { ComponentInteractionType, SceneComponent } from '@/_models/virtualStaging/Scene.component';
import { Inputs, Outputs } from '@/_models/virtualStaging/VRPointer/component/types';
import { LoadingState } from '@/_models/virtualStaging/VSObject';

export class VRPointerComponent extends SceneComponent {
  public root: any = null;

  public pivot: any = null;

  public pointerMesh: any;

  public hostPose: any;

  private vec3;

  inputs: Inputs = {
    visible: false,
    scale: 0.05,
    offset: {
      x: 0.006,
      y: -0.025,
      z: 0.03,
    },
  };

  outputs: Outputs = {
    loadingState: LoadingState.Idle,
  };

  events = {
    [ComponentInteractionType.CLICK]: false,
    [ComponentInteractionType.HOVER]: false,
    [ComponentInteractionType.DRAG]: false,
  };

  declare context: any;

  onInit() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();
    this.vec3 = new THREE.Vector3();
    this.root.add(this.pivot);
    this.outputs.objectRoot = this.root;
    this.root.visible = this.inputs.visible;
    this.pivot.visible = false;
    this.context.renderer?.xr?.addEventListener('sessionstart', () => {
      this.pivot.visible = true;
    });
    this.context.renderer?.xr?.addEventListener('sessionend', () => {
      this.pivot.visible = false;
    });
    this.createPointer();
  }

  createPointer() {
    const THREE = this.context.three;

    new THREE.TextureLoader().load('/images/pointer_vr.png', (texture) => {
      const material = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthWrite: false,
        depthTest: false,
      });

      const sprite = new THREE.Sprite(material);
      const { x, y, z } = this.inputs.offset;
      sprite.position.set(x, y, z);
      sprite.scale.setScalar(this.inputs.scale);
      sprite.renderOrder = 990;

      this.pointerMesh = sprite;
      this.pivot.add(sprite);

      this.outputs.loadingState = LoadingState.Loaded;
    });
  }

  setVisible(visible) {
    this.inputs.visible = visible;
  }

  onInputsUpdated(previousInputs: this['inputs']) {
    this.root.visible = this.inputs.visible;
  }

  cycleVR(_session) {
    this.hostPose.getWorldPosition(this.vec3);
    const { x, y, z } = this.vec3;
    this.root.lookAt(x, y, z);
  }

  onTick() {
    if (this.root && this.hostPose) {
      if (this.context?.renderer?.xr?.isPresenting) {
        const _session = this.context.renderer.xr.getSession();
        _session.requestAnimationFrame(() => this.cycleVR(_session));
      }
    }
  }

  onDestroy() {}
}

export const VRPointerComponentType = 'mp.VRPointerComponent';
export const makeVRPointerComponent = (): any => new VRPointerComponent();
